import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import product from '../../Assets/images/static/1.svg';
import deposit from '../../Assets/images/static/2.svg';
import form from '../../Assets/images/static/3.svg';
import transfer from '../../Assets/images/static/4.svg';

import Howhelp from '../component/Howhelp';


const About = () => {
    const { t, i18n } = useTranslation();
    const [socials, setSocials] = useState([]); 


    useEffect(() => {
      axios
        .get(`${API_BASE_URL}/about/social/`, {
          headers: {
            'Accept-Language': i18n.language
          }
        })
        .then(response => {
            setSocials(response.data);
        })
        .catch(error => {
          console.error('Ошибка при получении категорий:', error);
        });
    
    }, []);


  return (
    <div className="test_block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h3 className="main-content__main-products desktop-title tac">{t('about.title')}</h3>
                <div className="main-about__text">
                <p>
                {t('about.description1')} </p>

                <p>{t('about.description2')}
                </p>
                <p>
                {t('about.description3')} 
                </p>
                <p>
                {t('about.description4')} 
                </p>
                <p>
                {t('about.description5')} 
                </p>
                <p>
                {t('about.description6')}
                </p>
                <p>
                {t('about.description7')} </p>
                <p>
                {t('about.description8')}
                </p>
                    </div>
                </div>
                
                
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="contain-infor">
                    <h2>{t('about.logistics')} <span>Frigider Comunitar</span></h2>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-service">
                        <img src={product} alt={t('about.buyProducts')} />
                        <div className="tittle-serv">{t('about.buyProducts')}</div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-service">
                        <img src={deposit} alt={t('about.deliveryToWarehouse')} />
                        <div className="tittle-serv">{t('about.deliveryToWarehouse')}</div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-service">
                        <img src={form} alt={t('about.formingSets')} />
                        <div className="tittle-serv">{t('about.formingSets')}</div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-service">
                        <img src={transfer} alt={t('about.handingOverProducts')} />
                        <div className="tittle-serv">{t('about.handingOverProducts')}</div>
                    </div>
                </div>
            </div>
            <Howhelp />
            <div className="row">
                <div className="col-lg-12">
                    <div className="contain-infor">
                    <h2>{t('about.socialMedia')}</h2>
                    </div>
                </div>
                {Array.isArray(socials) && socials.length > 0 && socials.map(social => (
                <div key={social.id} className="col-lg-6">
                    <div className="main-about__team-box__person no_decor"> 
                        <div className="main-about__team-box__photo">
                            <img src={social.image} alt={social.title} />
                        </div> 
                        <div className="main-about__team-box__person-info"> 
                        <p className="main-about__team-box__person-name">{social.title}</p> 
                        <p className="main-about__team-box__person-position">{social.detail}</p> 
                        <a className="main-about__team-box__facebook-link select_none" rel="noreferrer" href={social.link} target="_blank"><svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path fill="#ffffff" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.3V327.7h-63V256h63v-54.6c0-62.2 37-96.5 93.7-96.5 27.1 0 55.5 4.8 55.5 4.8v61h-31.3c-30.8 0-40.4 19.1-40.4 38.7V256h68.8l-11 71.7h-57.8V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0 -48-48z"/></svg> {t('about.facebook')}</a> 
                        </div> 
                    </div>
                </div>
                ))}
            </div>
        </div>

    </div>
  )
}

export default About